module.exports = __webpack_public_path__ + "img/post-search.ea573087.svg";